import OrderTab from "../enum/OrderTab";

const OrderTabNameMap = {
    [OrderTab.PENDING_PAYMENT]: "未付款",

    [OrderTab.PENDING_SHIPMENT]: "待发货",

    [OrderTab.ON_HOLD]: "挂起",

    /** 已发货退款中 */
    [OrderTab.SHIPPED_REFUNDING]: "退款中",

    /** 待发货退款中 */
    [OrderTab.PENDING_SHIPMENT_REFUNDING]: "退款中",

    [OrderTab.SHIPPED]: "已发货",

    [OrderTab.SUCCESS]: "已成功",

    [OrderTab.CANCELED]: "已取消",

    [OrderTab.ABNORMAL]: "异常订单",

    [OrderTab.LOGISTICS_WARNING]: "物流异常预警",

    [OrderTab.PICKUP_DEADLINE_WARNING]: "发货后超时揽收预警",

    [OrderTab.PRE_SHIP]: "预发货",
};

export default OrderTabNameMap;
